import React, { useContext } from 'react';
import { UserRootPageView, UserRootPageViewProps } from './UserRootPage.view';
import { AppContext } from '../../../providers/AppProvider';

export const UserRootPageController = (): JSX.Element => {
  // Put All your methods and logic here
  const { postEditorContext, rightDrawerState, limitReachModalState, isSuspendedModalOpen } = useContext(AppContext);

  const viewProps: UserRootPageViewProps = {
    postEditorContext,
    rightDrawerState,
    isOpenLimitReachModalOpen: limitReachModalState.isOpen,
    isSuspendedModalOpen
  };
  return <UserRootPageView {...viewProps} />;
};
